import React from 'react';
import { StyledLoaderAnimation, StyledLoaderContainer, StyledLoaderText } from './styled';

const Loader = ({ text, skin }) => {
  return (
    <StyledLoaderContainer>
      <StyledLoaderAnimation skin={skin} />
      {!!text && <StyledLoaderText skin={skin}>{text}</StyledLoaderText>}
    </StyledLoaderContainer>
  );
};

export default Loader;
